import { createSelector } from "@ngrx/store";
import { getStreamState } from "../reducers";

export const streamToken = createSelector(
    getStreamState,
    (streamState) => streamState?.token
);

export const streamLoading = createSelector(
    getStreamState,
    (streamState) => streamState?.loading
);

export const streamInitiated = createSelector(
    getStreamState,
    (streamState) => streamState?.initiated
);